import { Dispatch, SetStateAction } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from '../../../../context/LocationContext';
import { PhoneInput } from '@ordr-as/umami-react/form';

interface Props {
  setPhoneNumber: Dispatch<SetStateAction<string | undefined>>;
  customPrice: number;
  error: boolean;
}

const GiftCardPhoneNumber = (props: Props) => {
  const { setPhoneNumber, customPrice, error } = props;
  const intl = useIntl();
  const { formatCurrency } = useLocation();

  const handlePhoneNumberInput = (phoneNumber: string) => {
    const phoneNumberWithoutSpaces = phoneNumber.replace(/\s/g, '');
    setPhoneNumber(phoneNumberWithoutSpaces);
  };

  return (
    <div className="flex flex-col">
      <span className="text-base text-bold mb-3">{formatCurrency(customPrice)}</span>
      <PhoneInput
        fullWidth
        required
        className="mb-[120px]"
        labelClassName="mb-2"
        label={intl.formatMessage({ id: 'items.giftCard.dialog.phone.title.input.label' })}
        description={intl.formatMessage({ id: 'items.giftCard.dialog.phone.input.description' })}
        sendPhoneNumberToParent={handlePhoneNumberInput}
        invalidHelpText={intl.formatMessage({ id: 'items.giftCard.dialog.phone.help.failure' })}
        validationState={error ? 'invalid' : undefined}
      />
    </div>
  );
};

export default GiftCardPhoneNumber;
